<template>
    <section v-if="hasPermissions(['Daily-Assignment Read', 'Daily-Assignment Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Pariatur dolorem cumque possimus nobis ut iure architecto, assumenda iste cupiditate libero sed debitis magni deleniti enim corporis veniam et aut. Et.
            </p>
        </div>

        <div id="header-filters" class="row" style="margin-top:30px; margin-bottom: 6vh;">
            <div class="header-filters--date col-md-2 py-0 mb-3 mb-md-0">
                <input class="date-input" type="date" v-model="search_date" v-if="hasPermissions(['Daily-Assignment Read'])">
            </div>
            <div  class="col-md-4 py-0 mb-3 mb-md-0" v-if="discharge_beds.length && hasPermissions(['Daily-Assignment Read'])">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div> 
        </div>
        
        <div class="tab-content" v-show="discharge_beds.length && hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                ref="dinamic_table"
                                :headers="table_headers"
                                :items="discharge_beds"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import axios from 'axios'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import DinamicTable from '@/components/DinamicTable'
import Resources from './resources'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'
import moment from 'moment'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "DischargeBeds",

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTable,
        UnauthorizedComponent
    },

    data() {
        return {
            notyf,
            axios,
            user:       this.get_user(),
            child_href: '/census-vacant-beds/',
            title_page: 'Discharged Beds',
            rest_api: `discharge_beds`,
            table_headers: Resources.table_headers,
            breadcrumb: Resources.breadcrumb,
            single_select: false,
            search: '',
            global_index: '',
            single_object: {},
            discharge_beds: [],
            array_options: {},
            search_date: '',
            moment
        }
    },

    methods: 
    {

        fill_data(data)
        {
            this.discharge_beds = data.discharge_beds
        },
    },

    watch: 
    {
        async search_date(val)
        {
            await this.api_request(`${this.rest_api}/${val}`)
        }

    },

    async mounted()
    {
        if(this.hasPermissions(['Daily-Assignment Read',  'Daily-Assignment Write']))
        {
            this.search_date = moment().format("YYYY-MM-DD")
            await this.api_request(`${this.rest_api}/${this.search_date}`)
        }
        
    },
};
</script>
<style scoped>
#header-filters .header-filters--date .date-input
{
    border-bottom: .02rem solid rgb(110, 160, 94);
}
</style>